import { FC, useRef } from 'react';
import FlightDetailsSkeleton from './FlightDetailsSkeleton';
import useFlight from 'hooks/useFlightDetails';
import FlightDetails from './FlightDetails';
import { useTranslation } from 'react-i18next';
import MultiTotalDetails from './MultiTotalDetails';
import { Outbound } from 'ts/flight/interfaces/FlightDetailsResponse';
import ExpiredToken from 'components/shared/ExpiredToken';
import * as idb from 'utils/shared/idbUrl';
import usePageInMemory from 'hooks/usePageInMemory';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { faArrowCircleLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/ui/Button/Button';
const MultiFlightPage: FC = () => {
  const [t] = useTranslation();

  const [urlParams] = useSearchParams();
  const location = useLocation();
  const idbKey = location.pathname + location.search;
  const { onClickBack, onClickSearch } = usePageInMemory(idbKey, () => saveState());
  const navigate = useNavigate();
  const {
    response,

    flexOrFlight,
    bounds,
    setFlexFlightId,
    flexFlightId,

    flexOrFlightPair,
    boundsPair,
    setFlexFlightIdPair,
    flexFlightIdPair,
  } = useFlight(idbKey, true);
  const stateRef = useRef<any>();
  stateRef.current = {
    flexFlightId,
    bounds,
    response,
    flexFlightIdPair,
    boundsPair,
  };
  useGetPage('Flights/Details');

  const getCodesArr = (bound?: Outbound) => {
    let result: string[] = [];
    if (bound) {
      result = bound.gdsFlyAirs.map((segment) => segment.departureAirport.code);
    }
    result.push(bound?.arrivalAirport.code || '');

    return result;
  };
  const onContinue = async () => {
    if (!flexOrFlight || !flexOrFlightPair) return;

    const searchParams = new URLSearchParams({
      searchToken: urlParams.get('searchToken') || '',
      pairSearchToken: urlParams.get('pairSearchToken') || '',
      id: flexFlightId || flexOrFlight.id,
      pairId: flexFlightIdPair || flexOrFlightPair.id,
    });

    navigate({ pathname: '/multiflight/book', search: searchParams.toString() });

    saveState();
  };

  const saveState = () => {
    idb.savePageState(idbKey, stateRef.current);
  };

  return (
    <div className="details-wrapper">
      <div className="details flight-details">
        {window.history.length > 1 && (
          <div className="mb-20 default-shadow flex-between dyn-change-header">
            <Button
              title={t('back')}
              icon={faArrowCircleLeft}
              onClick={() => onClickBack('flight', 'results')}
              className="btn btn-link"
            />
            <Button
              title={t('search.new')}
              icon={faSearch}
              onClick={() => onClickSearch('flight', '/flights')}
              className="btn btn-link"
            />
          </div>
        )}
        {!!flexOrFlight && (
          <div className="title text-underline">
            {t('flight.outbound')} ({getCodesArr(flexOrFlight.outbound).join(' - ')})
          </div>
        )}
        <FlightDetails
          flexFlightId={flexFlightId}
          response={response}
          flexOrFlight={flexOrFlight}
          setFlexFlightId={setFlexFlightId}
          bounds={bounds}
          googleMapOfAirports={response?.googleMapOfAirports}
          listFlexFlights={response?.flexDetails?.listOfFlexFlights}
          searchToken={urlParams.get('searchToken') || ''}
        />
        {!!flexOrFlightPair && (
          <div className="title text-underline">
            {t('flight.inbound')} ({getCodesArr(flexOrFlightPair.outbound).join(' - ')})
          </div>
        )}
        <FlightDetails
          flexFlightId={flexFlightIdPair}
          response={response}
          flexOrFlight={flexOrFlightPair}
          setFlexFlightId={setFlexFlightIdPair}
          bounds={boundsPair}
          googleMapOfAirports={response?.googleMapOfAirportsPair}
          listFlexFlights={response?.flexDetailsPair?.listOfFlexFlights}
          searchToken={urlParams.get('pairSearchToken') || ''}
        />
        {flexOrFlight && flexOrFlightPair && (
          <MultiTotalDetails
            flight={flexOrFlight}
            flightPair={flexOrFlightPair}
            onContinue={onContinue}
          />
        )}

        {response?.sessionExpired && <ExpiredToken storePath="flight" />}

        {!response && <FlightDetailsSkeleton />}
      </div>
    </div>
  );
};

export default withErrorBoundary(MultiFlightPage, 'MultiFlightPage');
